import { Component, inject, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml, Title } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-email-signature',
  templateUrl: './email-signature.component.html',
  styleUrls: ['./email-signature.component.scss'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None
})
export class EmailSignatureComponent {
  private clipboard = inject(Clipboard);
  private messageService = inject(MessageService);
  private sanitizer = inject(DomSanitizer);

  formGroup = new FormGroup({
    nome: new FormControl<string>(null, Validators.required),
    cargo: new FormControl<string>(null, Validators.required),
    email: new FormControl<string>(null, Validators.required),
    telefone: new FormControl<string>(null, Validators.required),
    selectedColor: new FormControl<string>('rgb(23, 178, 255)')
  });

  colorOptions = [
    { label: 'Azul', value: 'rgb(23, 178, 255)' },
    { label: 'Rosa', value: 'rgb(255, 0, 94)' }
  ];

  readonly logoUrl = 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_15539.png';

  constructor() {
    inject(Title).setTitle('Assinatura de e-mail');
  }

  get signatureHtml(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.buildSignatureHtml());
  }

  copySignature(): void {
    const html = this.buildSignatureHtml();
    const blob = new Blob([html], { type: 'text/html' });
    const item = new ClipboardItem({ 'text/html': blob });

    navigator.clipboard.write([item]).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Sucesso',
        detail: 'Assinatura copiada para a área de transferência!'
      });
    }).catch(() => {
      this.clipboard.copy(html);
      this.messageService.add({
        severity: 'info',
        summary: 'Copiado',
        detail: 'Assinatura copiada como texto HTML'
      });
    });
  }

  private buildSignatureHtml(): string {
    const c = this.formGroup.value.selectedColor;
    const nome = this.formGroup.value.nome || 'Seu Nome';
    const cargo = this.formGroup.value.cargo || 'Seu Cargo';
    const emailVal = this.formGroup.value.email || 'seuemail@b4a.com.br';
    const telVal = this.formGroup.value.telefone || '(00) 00000-0000';

    return `<table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, Helvetica, sans-serif; color: #333333;">
  <tr>
    <td style="padding-right: 16px; vertical-align: top;">
      <img src="${this.logoUrl}" alt="B4A" width="130" style="display: block;" />
    </td>
    <td style="border-left: 2px solid ${c}; padding-left: 16px; vertical-align: top;">
      <table cellpadding="0" cellspacing="0" border="0">
        <tr>
          <td style="font-size: 17px; font-weight: bold; color: #333333; padding-bottom: 2px; line-height: 22px;">
            ${nome}
          </td>
        </tr>
        <tr>
          <td style="font-size: 14px; color: ${c}; padding-bottom: 10px; line-height: 18px;">
            ${cargo}
          </td>
        </tr>
        <tr>
          <td style="font-size: 13px; color: #666666; padding-bottom: 4px; line-height: 18px;">
            <span style="color: ${c}; font-weight: bold;">E-Mail:</span>&nbsp; ${emailVal}
          </td>
        </tr>
        <tr>
          <td style="font-size: 13px; color: #666666; padding-bottom: 4px; line-height: 18px;">
            <span style="color: ${c}; font-weight: bold;">tel:</span>&nbsp; ${telVal}
          </td>
        </tr>
        <tr>
          <td style="padding-top: 8px;">
            <a href="https://www.b4a.com.br" style="font-size: 13px; color: ${c}; text-decoration: none; font-weight: bold;">www.b4a.com.br</a>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>`;
  }
}
